// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ik-0";